import { com, kotlin } from '@eidu/web'
import entityApiUrl from '../baseUrl'
import requireValidPaginationParameters from '../common/requireValidPaginationParameters'
import permissionPolicyDTO, { PermissionPolicyDTO } from '../../../../domain/permission/PermissionPolicyDTO'
import fetchAuthorized from '../../authorization/fetchAuthorized'
import KtList = kotlin.collections.KtList
import IndexedPaginatedResponse = com.eidu.api.pagination.IndexedPaginatedResponse

export type GetPermissionPoliciesParameters = { pageIndex: number; pageSize: number }

const getPermissionPolicies = async ({
  pageIndex,
  pageSize,
}: GetPermissionPoliciesParameters): Promise<IndexedPaginatedResponse<PermissionPolicyDTO>> => {
  requireValidPaginationParameters(pageIndex, pageSize)

  const response = await fetchAuthorized(
    (authContext) =>
      `${entityApiUrl}/organizations/${authContext.organizationId}/permissions/policies?pageIndex=${pageIndex}&pageSize=${pageSize}`,
    { headers: { Accept: 'application/json' } }
  )
  if (response.status !== 200)
    throw Error(`Unexpected response code ${response.status} from getPermissionPolicies endpoint`)
  const { documents, totalCount } = await response.json()
  const policies = documents.map(permissionPolicyDTO)
  return new IndexedPaginatedResponse(KtList.fromJsArray(policies), totalCount)
}

export default getPermissionPolicies
